import {
  detectionIcons,
  icons,
} from "../../../../../../../scenes/stack/environment/icons/iconExport";
import { ActivityLogType } from "../../../../../../../utils/constants";

export const expandButtonType = "expand";

export const logIconsMapping = {
  [ActivityLogType.NEW_GAP]: icons.ControlStatusGapIcon,
  [ActivityLogType.NEW_COMPLIANT]: icons.ControlStatusCompliantIcon,
  [ActivityLogType.TURNED_GAP]: icons.ControlStatusGapIcon,
  [ActivityLogType.TURNED_COMPLIANT]: icons.ControlStatusCompliantIcon,
  [ActivityLogType.ESCALATED]: icons.TrendDownIcon,
  [ActivityLogType.IMPROVED]: icons.TrendUpIcon,
  [ActivityLogType.NOT_APPLICABLE]: icons.ControlNotApplicableIcon,
  [ActivityLogType.APPLICABLE_GAP]: icons.ControlStatusGapIcon,
  [ActivityLogType.APPLICABLE_COMPLIANT]: icons.ControlStatusCompliantIcon,
  [ActivityLogType.EXCLUDED_ENTITIES]: icons.RemoveCircleIcon,
  [ActivityLogType.INCLUDED_ENTITIES]: icons.AddCircleIcon,
  [ActivityLogType.CONTROL_EXCLUDED]: icons.RemoveCircleIcon,
  [ActivityLogType.CONTROL_INCLUDED]: icons.AddCircleIcon,
  [ActivityLogType.CONTROL_SNOOZED]: icons.SnoozedIcon,
  [ActivityLogType.CONTROL_UNSNOOZED]: icons.SnoozedIcon,
  [ActivityLogType.CONTROL_SNOOZE_ENDED]: icons.SnoozedIcon,
  [ActivityLogType.SNOOZED_ENTITIES]: icons.SnoozedIcon,
  [ActivityLogType.UNSNOOZED_ENTITIES]: icons.SnoozedIcon,
  [ActivityLogType.ENTITY_SNOOZE_ENDED]: icons.SnoozedIcon,
  [ActivityLogType.SCAN]: icons.ScanIcon,
  [ActivityLogType.TICKET_UNLINKED]: icons.RemoveLinkIcon,
  [ActivityLogType.TICKET_DELETED]: icons.DeleteBinIcon2,
  [ActivityLogType.TICKET_UNLINKED_FOR_ENTITY]: icons.RemoveLinkIcon,
  [ActivityLogType.TICKET_DELETED_FOR_ENTITY]: icons.DeleteBinIcon2,
  [ActivityLogType.SEVERITY_RAISED]: icons.SetSeverityIcon,
  [ActivityLogType.SEVERITY_LOWERED]: icons.SetSeverityIcon,
  [ActivityLogType.REMEDIATION_PRIORITY_RAISED]: icons.SetPriorityIcon,
  [ActivityLogType.REMEDIATION_PRIORITY_LOWERED]: icons.SetPriorityIcon,
  [ActivityLogType.DETECTION_RESOLVED]: detectionIcons.DetectionBlack,
  [ActivityLogType.AUTO_REMEDIATION]: icons.MagicWandIcon,
  [expandButtonType]: icons.ExpandCommentIcon,
};
